export default {
    toastContainer: {
        position: "relative"
    },

    positionAbsolute: {
        position: "absolute",
        right: "30px",
        top: "100px",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        rowGap: "20px",
        maxWidth: "850px"
    }
}